<div class="p-8 bg-white rounded-xl shadow-lg w-full max-w-md">
  <div class="flex flex-col items-center text-center">
    <div class="flex items-end">
      <div class="text-yellow-400 mb-1 mr-2">
        <fa-icon [icon]="faTriangleExclamation" size="2xl"></fa-icon>
      </div>
      <h2 class="text-3xl font-bold text-neutral-950">
        {{ data.isLocking ? 'Lock' : 'Unlock' }} Section
      </h2>
    </div>
    <p class="text-neutral-950 mb-8 mt-4 whitespace-pre-line text-left">
      @if (data.isLocking) {
        {{ lockMessage }}
      } @else {
        {{ unlockMessage }}
      }
    </p>
    <div class="flex justify-center gap-4 w-full">
      <ui-button
        (click)="onCancel()"
        variant="secondary"
        [outline]="true"
        class="w-full"
        size="sm"
        >Cancel</ui-button
      >
      <ui-button (click)="onConfirm()" class="w-full" size="sm">{{
        data.isLocking ? 'Lock' : 'Unlock'
      }}</ui-button>
    </div>
  </div>
</div>
